import UsersApi from "@/api/users";
import { defineStore } from "pinia";
export const useUsers = defineStore("users", {
    state: () => ({
        users: {},
        forumId: -1,
        isFetching: false
    }),
    actions: {
        onLoad(userId, user) {
            if (this.users[userId]) {
                Object.assign(this.users[userId], user);
            }
            else {
                this.users[userId] = user;
            }
            return this.users[userId];
        },
        putUser(user) {
            return this.onLoad(user.userId, user);
        },
        getUsers(userIds, studyId) {
            this.isFetching = true;
            return UsersApi.getUsers(userIds, studyId)
                .then(({ users }) => {
                users.map((user) => this.onLoad(user.userId, user));
                return users;
            })
                .finally(() => {
                this.isFetching = false;
            });
        },
        getUser(userId) {
            return this.loadByUserId(userId);
        },
        loadByUserId(userId, studyId) {
            if (this.users[userId]) {
                return this.users[userId];
            }
            this.users[userId] = {
                userId: userId,
                displayName: "",
                admin: false,
                thumbnails: {}
            };
            UsersApi.getUserById({ userId }, studyId).then((user) => {
                this.onLoad(userId, user);
            });
            return this.users[userId];
        },
        getUsersForStudy(studyId) {
            this.isFetching = true;
            return UsersApi.getUsersForStudy(studyId)
                .then(({ users }) => {
                Object.assign(this.users, users.reduce((acc, user) => {
                    acc[user.userId] = user;
                    return acc;
                }, {}));
                return users;
            })
                .finally(() => {
                this.isFetching = false;
            });
        }
    }
});
